import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { AppErrorBoundary } from '../components/AppErrorBoundary';
import { resetChatSkillsCache } from '../features/chat/hooks/useChatSkills';
import { I18nProvider } from '../i18n/I18nProvider';
import { bindQueryClientToWorkspaceScope, createQueryClient } from '../lib/query-client';
import { ThemeProvider } from '../theme/ThemeProvider';

const queryClient = createQueryClient();
bindQueryClientToWorkspaceScope(queryClient, resetChatSkillsCache);

export function AppProvider({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppErrorBoundary>{children}</AppErrorBoundary>
        </QueryClientProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}
